import React from "react";
import Form from "../components/Form";

const ContactUs = () => {
  return (
    <div className="form-container d-flex justify-content-center mt-3">
      <Form />
    </div>
  );
};

export default ContactUs;
